import React from 'react';
import { MapPin, TrendingUp, Eye, MousePointerClick } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const LocalSEOPerformance = ({ performanceData, onRefresh }) => {
  // Group performance data by location
  const groupedData = performanceData?.reduce((acc, item) => {
    if (!acc?.[item?.location_name]) {
      acc[item.location_name] = [];
    }
    acc?.[item?.location_name]?.push(item);
    return acc;
  }, {}) || {};

  return (
    <div className="space-y-6">
      {/* Performance Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[
          {
            title: 'Average Ranking',
            value: '3.2',
            change: '+1.2',
            icon: TrendingUp,
            color: 'green'
          },
          {
            title: 'Total Impressions',
            value: '1,720',
            change: '+15%',
            icon: Eye,
            color: 'blue'
          },
          {
            title: 'Total Clicks',
            value: '235',
            change: '+23%',
            icon: MousePointerClick,
            color: 'purple'
          }
        ]?.map((stat, index) => {
          const Icon = stat?.icon;
          return (
            <div key={index} className="bg-white rounded-lg shadow-sm p-6">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 rounded-lg bg-${stat?.color}-100 flex items-center justify-center`}>
                  <Icon className={`w-6 h-6 text-${stat?.color}-600`} />
                </div>
                <span className="text-sm font-medium text-green-600">{stat?.change}</span>
              </div>
              <h3 className="text-gray-600 text-sm font-medium mb-1">{stat?.title}</h3>
              <p className="text-3xl font-bold text-gray-900">{stat?.value}</p>
            </div>
          );
        })}
      </div>
      {/* Location Performance */}
      {Object.entries(groupedData)?.map(([location, items]) => (
        <div key={location} className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-6">
            <div className="flex items-center gap-3">
              <MapPin className="w-6 h-6 text-white" />
              <h2 className="text-xl font-bold text-white">{location}</h2>
            </div>
            <p className="text-blue-100 mt-1">
              {items?.[0]?.county || 'Sacramento County'}
            </p>
          </div>

          <div className="p-6">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Search Term</th>
                    <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Ranking</th>
                    <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Search Volume</th>
                    <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">CTR</th>
                    <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Impressions</th>
                    <th className="text-center py-3 px-4 text-sm font-semibold text-gray-700">Clicks</th>
                  </tr>
                </thead>
                <tbody>
                  {items?.map((item, index) => (
                    <tr key={index} className="border-b border-gray-100 hover:bg-gray-50">
                      <td className="py-4 px-4">
                        <span className="font-medium text-gray-900">{item?.search_term}</span>
                      </td>
                      <td className="text-center py-4 px-4">
                        <span className={`inline-flex items-center justify-center w-10 h-10 rounded-full font-bold ${
                          item?.ranking_position <= 3 ? 'bg-green-100 text-green-700' :
                          item?.ranking_position <= 10 ? 'bg-yellow-100 text-yellow-700': 'bg-red-100 text-red-700'
                        }`}>
                          #{item?.ranking_position}
                        </span>
                      </td>
                      <td className="text-center py-4 px-4 text-gray-700">
                        {item?.search_volume?.toLocaleString() || 'N/A'}
                      </td>
                      <td className="text-center py-4 px-4">
                        <span className="font-medium text-gray-900">
                          {item?.click_through_rate ? `${item?.click_through_rate}%` : 'N/A'}
                        </span>
                      </td>
                      <td className="text-center py-4 px-4 text-gray-700">
                        {item?.impressions?.toLocaleString() || '0'}
                      </td>
                      <td className="text-center py-4 px-4 text-gray-700">
                        {item?.clicks?.toLocaleString() || '0'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
      {/* Refresh Button */}
      <div className="flex justify-center">
        <button
          onClick={onRefresh}
          className="px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
        >
          Refresh Performance Data
        </button>
      </div>
    </div>
  );
};

export default LocalSEOPerformance;